<form #contactForm="ngForm" style="display:inline" [ngClass]="{'_load-animate _load-active': loadingCustomer}">

  <!--<button mat-fab mat-dialog-close cdkFocusInitial class="loyalty-close" color="primary" (mousedown)="close()" *ngIf="wizardStep != stepsMap.requiered && wizardStep != stepsMap.terms_missing && wizardStep > 3">
  <mat-icon aria-label="Close Dialog">close</mat-icon>
</button>

<button  type="button" class="o-btn _xl _shadow brand-accent btn-block btn-close-outside"
  *ngIf="wizardStep < 3"
  (mousedown)="close(club)">
  <span>{{($storage.config?.settings.clubMethod == 'voucher' ? '_LOYALTY.not_interested_voucher' : '_LOYALTY.not_interested_club') | translate}}</span>
</button>-->

<div class="_dialog-title">
  <mat-icon svgIcon="logo" class="me-2"></mat-icon>
  <span>{{title}}</span>
</div>

<div class="_dialog-content" >
  <mat-tab-group class="wiz-tabs hide-headers" [selectedIndex]="wizardStep" [dynamicHeight]="true">
    <!------------------------------------------------------------------------------------->
    <!--LOYALTY CLUBS-->
    <!------------------------------------------------------------------------------------->
    <mat-tab>
      @if ($storage.loyaltyClubs[1]) {
        <div>
          @for (club of $storage.loyaltyClubs | slice:0:5; track club) {
            <button mat-raised-button color="accent" class="lg mt-3 btn-block main-continue-btn" type="button"
              (mousedown)="selectClub(club)">
              {{club.name}}
            </button>
          }
        </div>
        <div class="_bottom-actions mt-4">
          <button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
          <button type="button" mat-flat-button color="accent" class="rounded" disabled style="min-width: 120px">{{'continue' | translate}}</button>
        </div>
      } @else {
        <div [ngClass]="{'_load-animate _load-active': !loadingCustomer}" style="min-height: 200px">

        </div>
      }
    </mat-tab>
    <!------------------------------------------------------------------------------------->
    <!--LOYALTY LOGIN-->
    <!------------------------------------------------------------------------------------->
    <mat-tab>
      <div #pasteTarget style=" margin:0 auto">
        @if ($storage.loyaltyHeaderSubCaption) {
          <div class="_sub-title pre-wrap">{{($storage.loyaltyHeaderSubCaption || '_LOYALTY.loginSubCaption') | translate}}</div>
        }
        <div class="keypad-val-container">
          <div class="keypad-val brand-input-border" [class._hasVal]="ui.connectValue?.length">
            <div class="_cap">{{'_LOYALTY.connect_info' | translate}}</div>
            <div class="_val" [class.text-danger]="ui.connectOptions.invalid">{{ui.connectValue}}</div>
          </div>
        </div>
        <app-inline-keypad #loginKeypad [data]="ui.connectOptions" (onChange)="onPhoneKeyChange($event)"></app-inline-keypad>
    </div>

    <div class="_bottom-actions mt-4">
      <button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
      <button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="getCustomer()" [disabled]="!ui.connectValid" style="min-width: 120px">{{'continue' | translate}}</button>
    </div>

  </mat-tab>
  <!------------------------------------------------------------------------------------->
  <!--LOYALTY LOGIN_AUTH-->
  <!------------------------------------------------------------------------------------->
  <mat-tab>
    <div style="margin:0 auto">
      <div class="_sub-title pre-wrap">{{'_LOYALTY.auth_sub_title' | translate}}</div>
      <div class="keypad-val-container">
        <div class="keypad-val brand-input-border" [class._hasVal]="ui.authValue?.length">
          <div class="_cap">{{'_LOYALTY.auth_code' | translate}}</div>
          <div class="_val" [class.text-danger]="!ui.authValid">{{ui.authValue}}</div>
        </div>
      </div>
      @if (!ui.loadingAuth) {
        <app-inline-keypad [data]="ui.auth_connectOptions" (onChange)="onAuthKeyChange($event)"></app-inline-keypad>
      }
      <div class="_sub-footer text-center text-accent mt-3" (click)="authResend()">{{'_LOYALTY.auth_resend' | translate}}</div>
    </div>

    <div class="_bottom-actions mt-4">
      <button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
      <button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="authCustomer()" [disabled]="!ui.authValid" style="min-width: 120px">{{'continue' | translate}}</button>
    </div>
  </mat-tab>
  <!------------------------------------------------------------------------------------->
  <!--LOYALTY TERMS MISSING-->
  <!------------------------------------------------------------------------------------->
  <mat-tab>
    @if (wizardStep == stepsMap.terms_missing) {
      <div class="mb-3">{{ '_LOYALTY_REG.terms_required_description' | translate }}</div>

      <app-loyalty-registration-form #regFields [source]="registerFields"
        [fields]="$storage.loyaltyClub.regInfo.requiredFields"
      [required]="true"></app-loyalty-registration-form>
      <div class="mb-3">
        @if ($storage.loyaltyClub?.regInfo?.termsFile) {
          <div class="mb-3">
            <div>
              <mat-checkbox [(ngModel)]="terms.readContract" name="readContract"
                [color]="warn">
                <span style="white-space:pre-line"
                  [class.text-danger]="!terms.readContract && ui.contractWarning">
                  {{ $storage.loyaltyClub?.regInfo?.textForConfirmClubRules || ('_LOYALTY_REG.registration_contract' | translate) }}
                </span>
              </mat-checkbox>
            </div>
            <a class="a-link ms-2" (click)="openRegContract()"
              style="display:block; font-weight:600">
              {{ '_LOYALTY_REG.read_contract' | translate }}
            </a>
          </div>
        }
        <div>
          <mat-checkbox [(ngModel)]="terms.acceptTerms" name="acceptTerms" [color]="warn">
            <span style="white-space:pre-line"
            [class.text-danger]="!terms.acceptTerms && ui.regWarning">{{ $storage.loyaltyClub?.regInfo?.textForConfirmSms || ('_LOYALTY_REG.registration_terms' | translate) }}</span>
          </mat-checkbox>
        </div>

        @if (loyaltyService.loyaltyMember?.workFlow != 'none' && $storage.loyaltyClub?.regInfo?.clubRegMessage) {
          <div class="mb-3">{{ $storage.loyaltyClub.regInfo.clubRegMessage }}</div>
        }
      </div>

      <div class="_bottom-actions d-flex align-items-center mt-3">
        <button mat-button color="accent" (mousedown)="skipTerms()">{{ '_LOYALTY_REG.no_thanks' | translate }}
        </button>
        <div class="flex-grow-1"></div>
        <button type="button" mat-flat-button color="accent" class="rounded"
          (mousedown)="updateTerms()"
          style="min-width: 120px">{{ 'continue' | translate }}
        </button>
      </div>
    }
  </mat-tab>
  <!------------------------------------------------------------------------------------->
  <!--ACCOUNT UPDATE-->
  <!------------------------------------------------------------------------------------->
  <mat-tab>
    @if (wizardStep == stepsMap.account_update) {

      <div class="pre-wrap">{{ '_LOYALTY_REG.after_reg_add_details_description' | translate }}</div>
      <app-loyalty-registration-form #regOptionalFields
        [source]="registerOptionalFields"
        [fields]="$storage.loyaltyClub.regInfo.optionalFields"
      [required]="false"></app-loyalty-registration-form>

      <div class="_bottom-actions d-flex align-items-center mt-3">
        <button mat-button color="accent"
          (mousedown)="afterRegSkip()">{{ '_LOYALTY_REG.another_time' | translate }}
        </button>
        <div class="flex-grow-1"></div>
        <button type="button" mat-flat-button color="accent" class="rounded"
          (mousedown)="afterRegUpdate()"
          style="min-width: 120px">{{ 'continue' | translate }}
        </button>
      </div>
    }
  </mat-tab>
  <!------------------------------------------------------------------------------------->
  <!--REQUIERED OFFERS-->
  <!------------------------------------------------------------------------------------->
  <mat-tab>
    @if (wizardStep == stepsMap.requiered) {

      @if (requiereInvitation) {
        <div class="mb-3">{{ '_LOYALTY_REG.sms_additional_info_sent_update' | translate }}</div>
      }
      @if (!loyaltyService.loyaltyData.isRegister) {
        @if (loyaltyService.loyaltyMember.workFlow == 'CustomerExpired' && loyaltyService.customer.customerMembershipExpire) {
          <div class="mb-3">
            <div>{{ '_LOYALTY_REG.membership_expired_at' | translate }}
              :&nbsp;{{ loyaltyService.customer.customerMembershipExpire | date }}
            </div>
            @if (info.configurations.accountSettings?.isShowPointsBalanceInPos && info.balance.points) {
              <div>{{ '_LOYALTY.points_balance' | translate }}
                :&nbsp;{{ info.balance.points | number:'0.0-0' }}
              </div>
            }
          </div>
        }
        <div class="mb-3">{{ loyaltyService.loyaltyMember?.requiereOffersMessage | translate }}</div>
      }

      @if (loyaltyService.loyaltyData.isRegister && loyaltyService.loyaltyMember?.requiereOffersMessage) {
        <div class="mb-3 pre-wrap" >{{ loyaltyService.loyaltyMember.requiereOffersMessage | translate }}</div>
      }

      <div class="_bottom-actions d-flex align-items-center mt-3">
        @if (!data.disableDisconnect) {
          <button mat-button color="accent"
            (mousedown)="signOut()">{{ '_LOYALTY.signout' | translate }}
          </button>
        }
        <div class="flex-grow-1"></div>
        @if (!hasNext) {
          <button type="button" mat-flat-button color="accent" class="rounded"
            (mousedown)="continue()"
            style="min-width: 120px">{{ 'approve' | translate }}
          </button>
        }
      </div>
    }
  </mat-tab>
  <!------------------------------------------------------------------------------------->
  <!--ACCOUNT-->
  <!------------------------------------------------------------------------------------->
  <mat-tab>
    @if (wizardStep == stepsMap.account) {
      @if (info) {
        <div class="loyalty-info-section">
			<div>
		        <div class="_loyalty-info text-acc">
<!--					@if (loyaltyService.customer.birthDate) {
						<div>
							<mat-icon svgIcon="birthday" class="me-1 base"></mat-icon>
							<span>{{ loyaltyService.customer.birthDate | date }}</span>
						</div>
					}
					@if (loyaltyService.customer.cardNumber) {
						<div>
							<mat-icon svgIcon="lcard" class="me-1 base"></mat-icon>
							<span>{{ loyaltyService.customer.cardNumber | card }}</span>
						</div>
					}-->
					@if (loyaltyService.customer.mobile) {
						<div>
							<mat-icon svgIcon="mobile" class="me-1 base" style="line-height: 12px;"></mat-icon>
							<span class="ltr">{{ loyaltyService.customer.mobile | phone }}</span>
						</div>
					}
				</div>
				<!--START BALANCE-->
				@if (info.balance.visibility.pointsVisible || info.balance.visibility.compsVisible || info.balance.visibility.prepaidVisible || info.balance.visibility.pointsStoreVisible) {
					<div class="_loyalty-balance">
						@if (info.balance.visibility.pointsVisible) {
							<div>
								<strong
									[class.text-lt]="info.balance.visibility?.pointsDisabled">{{ info.balance.cashBackPoints | number:decimalFormat }}</strong>
								<span>{{ info.pointsNickName || ('_LOYALTY.points_balance' | translate) }}</span>
							</div>
						}
						@if (info.balance.visibility.compsVisible) {
							<div>
								<strong>{{ info.balance.moneyCompensation | lcurrency }}</strong>
								<span>{{ '_LOYALTY.compensation' | translate }}</span>
							</div>
						}
						@if (info.balance.visibility.prepaidVisible) {
							<div>
								<strong>{{ info.balance.prePaid | lcurrency }}</strong>
								<span>{{ '_LOYALTY.card_balance' | translate }}</span>
							</div>
						}
						@if (info.balance.visibility.pointsStoreVisible) {
							<div>
								<strong
									[class.text-lt]="info.balance.visibility?.pointsDisabled">{{ ($storage.loyaltyOffersMap ? $storage.loyaltyOffersMap.remainingPoints : info.balance.pointsStorePoints) | number:decimalFormat }}</strong>
								<span>{{ info.pointsNickName || ('_LOYALTY.store_points' | translate) }}</span>
							</div>
						}
					</div>
				}
				<!--END BALANCE--></div>

          @if ((loyaltyService.loyaltyMember.workFlow == 'CustomerExpired' && loyaltyService.customer.customerMembershipExpire) || loyaltyService.loyaltyMember.requiereOffersMessage) {
            <div class="alert alert-primary text-center">
              @if (loyaltyService.loyaltyMember.workFlow == 'CustomerExpired' && loyaltyService.customer.customerMembershipExpire) {
                <div>
                  {{ '_LOYALTY_REG.membership_expired_at' | translate }}:&nbsp;{{ loyaltyService.customer.customerMembershipExpire | date }}
                </div>
              }
              @if (loyaltyService.loyaltyMember.requiereOffersMessage) {
                <div class="pre-wrap">
                  {{ loyaltyService.loyaltyMember.requiereOffersMessage | translate }}
                </div>
              }
            </div>
          }
          <!--START_BENEFITS-->
          <!--start manual benefits-->
          @if (loyaltyService.loyaltyMember.$manualBenefits) {

            <div class="text-center">
              <div class="loyalty-info-section-header">{{ '_LOYALTY.select_benefits' | translate }}</div>
              <div>
                @if (loyaltyService.loyaltyMember.$manualBenefits_limit) {
                  @if (loyaltyService.loyaltyMember.$maxManualBenfits) {
                    <div class="loyalty-info-section-info mb-1">
						@if (loyaltyService.loyaltyMember.$maxManualBenfits < 10) {
							{{ '_LOYALTY.select_benefits_range' | translate: {max: loyaltyService.loyaltyMember.$maxManualBenfits, val: loyaltyService.loyaltyMember.$manualBenefitsSelected} }}
						} @else if (!loyaltyService.loyaltyMember.$manualBenefitsSelected) {
							{{ '_LOYALTY.no_benefits_selected' | translate }}
						} @else if (loyaltyService.loyaltyMember.$manualBenefitsSelected == 1){
							{{ '_LOYALTY.one_benefit_selected' | translate }}
						} @else {
							{{ '_LOYALTY.select_benefits_count' | translate: {val: loyaltyService.loyaltyMember.$manualBenefitsSelected} }}
						}
					</div>
                  }
                  <div class="_loyalty-manual-benefits-cards pt-3">
                    @for (offer of loyaltyService.loyaltyMember.$manualBenefits; track offer) {
						@if (offer.redeemInfo?.isUnderGeneralRedeemLimit) {
							<button type="button" class="btn position-relative text-sm shadow-btn d-flex align-items-center"
		                            [ngClass]="offer.active ? 'btn-alt3' : 'btn-alt3-bordered'"
		                            (click)="selectManualBenefit(offer)">
								<div class="flex-grow-1">{{ offer.description }}</div>
								<mat-icon [svgIcon]="offer.active ? 'trash' : 'edit_alt'" style=""></mat-icon>
							</button>
						}
                    }
                  </div>
                }
                @if (loyaltyService.loyaltyMember.$manualBenefits_unlimit) {
                  @if (loyaltyService.loyaltyMember.$manualBenefits_limit) {
                    <hr class="loyalty-hr"/>
                    <div class="loyalty-info-section-info">
						{{ '_LOYALTY.select_additional_benefits' | translate }}
					</div>
                  }
                  <div class="_loyalty-manual-benefits-cards pt-3">
                    @for (offer of loyaltyService.loyaltyMember.$manualBenefits; track offer) {
						@if (!offer.redeemInfo?.isUnderGeneralRedeemLimit) {
							<button type="button" class="btn position-relative text-sm shadow-btn"
		                            [ngClass]="offer.active ? 'btn-alt3' : 'btn-alt3-bordered'"
		                            (click)="selectManualBenefit(offer)">
								<div>{{ offer.description }}</div>
							</button>
						}
                    }
                  </div>
                }
              </div>
            </div>
          }
          <!--end manual benefits-->
          <!--start auto benefits-->

          @if (benefits) {
			  <div>
				  <div class="loyalty-info-section-header mb-3">{{'_LOYALTY.your_auto_benefits' | translate}}</div>
				  <ul class="list-group list-group-flush">
					  @for (offer of benefits; track offer) {
						  <li class="list-group-item d-flex align-items-center" style="gap:5px; padding: 8px 4px;">
							  <mat-icon svgIcon="loyalty_logo" class="me-2 txt-accent-3"></mat-icon>
							  <div class="g-1">{{ offer.description }}</div>
							  @if (offer.expired) {
								  <small>
									  {{ '_LOYALTY.expires' | translate }}:&nbsp;
									  <strong>{{ offer.expired | date }}</strong>
								  </small>
							  }
						  </li>
					  }
				  </ul>
			  </div>
          }
          <!--end auto benefits-->
          <!--END_BENEFITS-->
          @if(loyaltyService.customer.requiereInvitation) {
            <div>{{'_LOYALTY_REG.sms_additional_info_sent_update' | translate}}</div>
          }
        </div>
      }
      <div class="_bottom-actions d-flex align-items-center mt-3">
        @if (!data.disableDisconnect) {
          <button mat-button color="accent"
            (mousedown)="signOut()">{{ '_LOYALTY.signout' | translate }}
          </button>
        }
        <div class="flex-grow-1"></div>
        @if (!hasNext) {
          <button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="continue()" style="min-width: 120px">{{'continue' | translate}}</button>
        }
      </div>
    }
  </mat-tab>
  <!------------------------------------------------------------------------------------->
  <!--POINTS-->
  <!------------------------------------------------------------------------------------->
  <mat-tab>
    @if (wizardStep == stepsMap.points) {
      <div>
        <div class="points-subtitle">
          <div class="text-accent">
            <div>{{'_LOYALTY.points_balance' | translate}}:</div>
            <div>{{ui.pointsOptions.pointsBalance}}</div>
          </div>
          <div class="_strong" [ngClass]="{'button-shake-fast text-danger': ui.pointsOptions.invalid}">
            <div>{{'_LOYALTY.max_redeemable_points' | translate}}:</div>
            <div>{{ui.pointsOptions.maxVal}}</div>
          </div>
          <!--<div>
          <div>{{'total-order' | translate}}:</div>
          <div>{{$storage.order.grandTotal | lcurrency}}</div>
        </div>-->
      </div>
      <div class="keypad-val-container">
        <div class="keypad-val brand-input-border" [class._hasVal]="ui.pointsOptions.amountText?.length">
          <div class="_cap">{{'_LOYALTY.use_points' | translate}}</div>
          <div class="_val" style="font-size: 18px" [class.text-danger]="ui.pointsOptions.invalid">{{ui.pointsOptions.amountText}}</div>
        </div>
      </div>
      <app-inline-keypad [data]="ui.pointsOptions" (onChange)="onPointsChange($event)"></app-inline-keypad>
    </div>
    <div class="_bottom-actions d-flex align-items-center mt-3">
      <button mat-button color="accent"  (mousedown)="close()">{{'Cancel' | translate}}</button>
      <div class="flex-grow-1"></div>
      <button type="button" mat-flat-button color="accent" class="rounded" (mousedown)="applyPoints()"
        [class.loading]="loadingCustomer"
        [disabled]="ui.pointsOptions.invalid"
      style="min-width: 120px">{{'continue' | translate}}</button>
    </div>
  }
</mat-tab>
</mat-tab-group>
</div>
</form>





